import FaqRoute from "./faq.js";

// Conduct is effectively a faq alias
export default class ConductRoute extends FaqRoute {
  pageId = "conduct";
}
